
/* System defined core library */
import { Component, Input } from '@angular/core';
import { Subscription } from 'rxjs';

/* User defined models */
import { PersonDetail } from '../../../../shared/models/scheduling/personalDetail.model';
import { TranslateService } from '@ngx-translate/core';
import { SelectedExamDetailService } from '../../services/selected-exam-detail.service';

@Component({
    selector: 'app-personal-detail',
    templateUrl: './personal-detail.component.html',
    styleUrls: ['./personal-detail.component.scss']
})

export class PersonalDetailComponent {


    translateLanguage$: Subscription;

    /* Input-OutPut parameters decalartions */
    @Input() personDetail: PersonDetail;

    /* Constructor declaration with required injected services */
    constructor(
        private translate: TranslateService,
        private selectedExamDetailService: SelectedExamDetailService
    ) {
        translate.setDefaultLang(this.selectedExamDetailService.defaultLanguageCode);
        this.translateLanguage$ = selectedExamDetailService.languageCode.subscribe(
            languageCode => {
                translate.use(languageCode);
            }
        );
    }
}
